const edit = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M1 14.032h14v1.718H1zM9.668 0l2.94 2.165-7.501 9.77-2.497.104-.443-2.268z"/></svg>',
};

export { edit as default };
